'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Scope = exports.Scope = {
  abandonedCartReminder: 'abandoned-cart-reminder',
  full: 'full'
};


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/unsubscribe.js
// module id = 360
// module chunks = 0